import React from 'react';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { Maybe, TransactionAccountProduct } from '@css-xp/graphtypes/src/generated-types-new';
import { SubscriptionWidgetItem, SubscriptionWidgetTable } from '../../widget';

type Subscriptions = Maybe<
  | Array<
      Maybe<
        Pick<
          TransactionAccountProduct,
          | 'id'
          | 'baseProduct'
          | 'transactionAccountId'
          | 'entitlementNumber'
          | 'latestPeriodEndDate'
          | 'latestPeriodStartDate'
          | 'productName'
          | 'productId'
          | 'cloudSiteId'
          | 'cloudSiteHostname'
        >
      >
    >
  | undefined
>;

export const getUpcomingRenewalWidgetContent = (
  subscriptions: Subscriptions,
  loading: boolean,
  heading?: string,
  version?: number
) => {
  if (loading) {
    return <LoadingIndicator />;
  }
  if (!subscriptions || !subscriptions.length) {
    return null;
  }

  if (version === 2) {
    return <SubscriptionWidgetTable subscriptions={subscriptions} heading={heading} isRenewSoonInterface />;
  }

  return subscriptions.map((subscription, index) => {
    if (!subscription || !subscription.transactionAccountId) {
      return null;
    }
    const URL = getRouteUrl(routePaths.entitlement, {
      txaId: subscription.transactionAccountId,
      entitlementId: subscription.id,
    });
    return (
      <SubscriptionWidgetItem
        timestamp={subscription.latestPeriodEndDate}
        url={URL}
        key={index}
        belowDayTimestampContent="Due soon"
        {...subscription}
        timePrefix="Due "
        heading={heading}
      />
    );
  });
};
